import { render, staticRenderFns } from "./InfoUser.vue?vue&type=template&id=6b7e9119&"
import script from "./InfoUser.vue?vue&type=script&lang=ts&"
export * from "./InfoUser.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports